var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShare = function SvgShare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3F46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.5 10.833v1.334c0 1.866 0 2.8-.363 3.513a3.334 3.334 0 0 1-1.457 1.457c-.713.363-1.647.363-3.513.363H7.833c-1.866 0-2.8 0-3.513-.363a3.333 3.333 0 0 1-1.457-1.457c-.363-.713-.363-1.647-.363-3.513v-1.334m4.167-5.12a16.94 16.94 0 0 1 2.84-3.033A.767.767 0 0 1 10 2.5m0 0c.18 0 .355.064.492.18 1.068.89 2.022 1.91 2.841 3.033M10 2.5v10.833"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export default ForwardRef;